import {i18n} from '@yourcoach/i18n';

import type {BaseConfig} from '../utils';
import type {SendInvitesParams} from './inviteSend/types';
import type {InviteTarget} from './types';

import SuccessIcon from '../../../assets/icons/primary/Tick Square.svg';
import {alert} from '../../../components/alert';
import {AppError} from '../../../utils/errors/app';
import {logger} from '../../../utils/logger';
import {SendInvitesStrategyFactory} from './inviteSend/SendInvitesStrategyFactory';

export {inviteSend};

type Config = BaseConfig<SendInvitesParams> & {
  showSuccessMessage?: boolean;
  target: InviteTarget;
};

async function inviteSend() {
  throw new AppError(
    'Common strategy is not defined. Use inviteSend.asCoach() instead.',
  );
}

inviteSend.asCoach = asCoach;

async function asCoach({params, showSuccessMessage = true, target}: Config) {
  try {
    const sendStrategy = SendInvitesStrategyFactory.createStrategy(
      target,
      params,
    );

    const {message, title} = await sendStrategy.sendInvites();

    if (showSuccessMessage) {
      logger.event('send_invite_success_view');
      alert.show({
        buttons: [
          {
            label: i18n.t('shared:great_excl'),
            scheme: 'primary',
          },
        ],
        icon: SuccessIcon,
        iconColor: 'icon4',
        message,
        title,
      });
    }
  } catch (e) {
    logger.error(e);

    throw e;
  }
}
